import { interWbHttp } from '@interco/inter-webview-bridge'

import { LeadMortgageData } from './types'

export const leadMortgage = async (data: LeadMortgageData) => {
  const endpoint = '/app-pf/crm-mc/v1/broker/contact/lead-mortgage'

  const headers = {
    'Content-Type': 'application/json',
  }

  const { response } = await interWbHttp.post({
    endpoint,
    body: data,
    headers,
  })

  return JSON.parse(response)
}
